// extracted by css-extract-rspack-plugin
module.exports =  {"radioWrapper":"Radio__radioWrapper--Rfmb1","indicator":"Radio__indicator--tGtxj","container":"Radio__container--YwZW2"};